import React, { useState, useEffect, useRef } from 'react';
import { Container, Row, Col, Button, Form, InputGroup, ListGroup, Modal } from 'react-bootstrap';
import '../scss/real-estate-agents.scss';
import LocationIcon from '../assets/images/location-icon-4.svg';
import UserIcon from '../assets/images/user.svg';
import SearchIcon from '../assets/images/search-white-icon.svg.svg';
import StarIcon from '../assets/images/star.svg';
import AgentsImage1 from '../assets/images/agent-img-1.png';
import AgentsImage2 from '../assets/images/agent-img-2.png';
import AgentsImage3 from '../assets/images/agent-img-3.png';
import AgentsImage4 from '../assets/images/agent-img-4.png';
import AgentsImage5 from '../assets/images/agent-img-5.png';
import { GET_AGENT_LIST, SAVE_AGENT_RATING } from '../api/constants';
import useSuburbs from "../hooks/useSuburbs";
import ContactAgentModal from "./ContactAgentModal";
import Rating from "react-rating";
import { FaStar, FaRegStar } from "react-icons/fa";
import Swal from 'sweetalert2';


function RealEstateAgents() {
  const { suburbs } = useSuburbs();
  const [suburb, setSuburb] = useState('')
  const [filtered, setFiltered] = useState([]);
  const inputGroupRef = useRef(null);
  const [inputHeight, setInputHeight] = useState(0);
  const [agents, setAgents] = useState([]);
  const [agent_id, setAgentID] = useState('')
  const [selected_agent_name, setSelectedAgentName] = useState('')
  const [active, setActive] = useState(false)
  const [agent_name, setAgentName] = useState('')
  const [showContactModal, setShowContactModal] = useState(false)
  const handleCloseContactModal = () => setShowContactModal(false);
  const [showRatingModal, setShowRatingModal] = useState(false)
  const [review, setReview] = useState('')
  const [rating, setRating] = useState(1)
    const [error, setError] = useState('')

  let token = localStorage.getItem("token");
  function redirectToLogin() {
    if (!token) {
      window.location.href = "/sign-in";
    }
  }


  const handleChange = (e) => {
    const value = e.target.value;
    setSuburb(value);

    if (value.length > 0) {
      const results = suburbs.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      );
      setFiltered(results);
    } else {
      setFiltered([]);
    }
    if (value != "") {
      setActive(true)
    } else {
      setActive(false)
    }
  };
  useEffect(() => {
    setActive(agent_name.trim() !== "");
  }, [agent_name]);
  const handleSelect = (item) => {
    setSuburb(item);

    setFiltered([]);
  };
  const fetchAgents = async (
    redirect = false,
    suburbOverride = suburb,
    agentOverride = agent_name
  ) => {
    try {
      let url = GET_AGENT_LIST;
      let redirectURL = "";

      const suburbName = suburbOverride
        ? suburbOverride.split(",")[0].trim()
        : "";

      const params = new URLSearchParams();

      if (suburbName) params.append("suburb", suburbName);
      if (agentOverride) params.append("name", agentOverride);

      if (params.toString()) {
        url = `${GET_AGENT_LIST}?${params.toString()}`;
        redirectURL = `/find-an-agent?${params.toString()}`;
      }

      console.log("FETCH:", url);

      const response = await fetch(url);
      const data = await response.json();

      if (data.status) {
        setAgents(data.data);

        if (redirect && redirectURL) {
          window.location.href = redirectURL;
        }
      } else {
        setAgents([]);
      }
    } catch (err) {
      console.error("Error fetching agents:", err);
    }
  };



  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const suburbParam = params.get("suburb") || "";
    const nameParam = params.get("name") || "";

    setSuburb(suburbParam);
    setAgentName(nameParam);

    // fetch using URL values (not empty state)
    fetchAgents(false, suburbParam, nameParam);
  }, []);


  useEffect(() => {
  }, [agents]);

  console.log(active);

   const saveRating = async (e) => {
        const token = localStorage.getItem("token");

      e.preventDefault();
      try {
        const res = await fetch(SAVE_AGENT_RATING, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...(token && { Authorization: `Bearer ${token}` }),
          },
          body: JSON.stringify({
            agent_id:agent_id,
            rating:rating,
            review:review
            
          }),
        });
  
        const data = await res.json();
  
        if (!res.ok) {
          throw new Error(data.message || "Failed to submit rating");
        }
  
        if (data.status) {
          Swal.fire({
            title: 'Success!',
            text: data.message,
            icon: 'success',
            confirmButtonText: 'OK',
            confirmButtonColor: '#0abab5'
          });
          fetchAgents(true)
          setRating('')
          setReview('')
          setShowRatingModal(false)

        }else{
          setError(data.errors)
        }
      } catch (err) {
        console.error("Viewing request error:", err.message);
      }
    };
  


  return (
    <section className="real-estate-agents-section common-padding">
      <Container>
        <div className="common-header text-center">
          <h2>Real Estate Agents in <span> Kenya</span></h2>
          <p>With over a million agents from all the top brokerages, a local agent knows your market and can guide you through the process from start to finish</p>
        </div>
        <div className="agent-search-bar">
          <Form>
            <Row className="align-items-center">
              <Col md={5} sm={12}>
                <div className="search-input-wrapper">

                  <img className="search-icon user-icon" src={LocationIcon} alt='' />
                  <Form.Control className='search-input' value={suburb} type="text" onChange={handleChange} placeholder="Enter Suburb" />

                  {filtered.length > 0 && (
                    <ListGroup style={{ top: inputHeight + 4, }}>
                      {filtered.map((item, index) => (
                        <ListGroup.Item
                          key={index}
                          action
                          onClick={() => handleSelect(item)}
                        >
                          <img src={Location} alt="" /> {item}
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  )}
                </div>
              </Col>
              <Col md={4} lg={5} sm={12}>
                <div className="search-input-wrapper">
                  <img className="search-icon user-icon" src={UserIcon} alt='' />
                  <Form.Control className='search-input' value={agent_name} onChange={(e) => setAgentName(e.target.value)} type="text" placeholder="Agent Name" />
                </div>
              </Col>
              <Col md={3} lg={2} sm={12}>
                <Button
                  className="custom-bttn style-3 non-ani w-100 left"
                  onClick={fetchAgents}
                  disabled={!active}  // ✅ disabled when active is false
                >
                  <img src={SearchIcon} alt="" />
                  Find Agent
                </Button>


              </Col>
            </Row>
          </Form>
        </div>

        {/* Agent Cards */}
        <Row className="g-4 agent-cards-row">
          {agents.map((agent) => (
            <Col lg={6} md={6} sm={12} key={agent.id}>
              <div className={`agent-card bg-${agent.bgColor}`}>
                <div className="agent-header">
                  <div className="agent-profile">
                    <div className="agent-avatar-wrapper">
                      <img src={agent.profile_photo ? agent.profile_photo : AgentsImage1} alt={agent.first_name} className="agent-avatar" />
                    </div>
                    <div className="agent-info">
                      <span className="team-badge">Agent</span>
                      <h3 className="agent-name">{agent.first_name} {agent.last_name}</h3>
                      <p className="agent-team">
                        {agent.companies?.length
                          ? agent.companies.map(c => c.name).join(", ")
                          : "Independent Agent"}
                      </p>

                      <div className="agent-rating">
                        <img src={StarIcon} alt="star icon" />
                        <span>{agent.avg_rating}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="agent-stats">
                  <div className="stat-row">
                    <span className="stat-label">Email</span>
                    <span className="stat-value">{agent.email}</span>
                  </div>
                  <div className="stat-row">
                    <span className="stat-label">Address</span>
                    <span className="stat-value">{agent.office_address}</span>
                  </div>
                  <div className="stat-row">
                    <span className="stat-label">Areas Covered</span>
                    <span className="stat-value">
                      {agent.suburbs?.length
                        ? agent.suburbs.map(s => s.name).join(", ")
                        : "—"}
                    </span>

                  </div>
                </div>

                <Row className="mb-3 mt-3" >
                  <Col xs={12} md={4}>
                    <Button
                      onClick={() => {
                        setAgentID(agent.id);
                        setShowContactModal(true);
                        setSelectedAgentName(agent.first_name + " " + agent.last_name);
                      }}
                      className="custom-bttn style-3 w-100"
                    >
                      Contact Agent
                    </Button>
                  </Col>
                  <Col xs={12} md={4}>
                    <Button
                      onClick={() => {
                        setAgentID(agent.id);
                        token !=null? setShowRatingModal(true) : redirectToLogin();
                      }}
                      className="custom-bttn style-2 w-100 mb-3"
                    >
                      Rate Agent
                    </Button>
                  </Col>
                </Row>

              </div>
            </Col>
          ))}
        </Row>

        {/* View More Button */}
        {/* <div className="view-more-wrapper">
          <Button className="custom-bttn style-3">View More</Button>
        </div> */}
      </Container>
      <ContactAgentModal agent_id={agent_id} show={showContactModal} agent_name={selected_agent_name} handleClose={handleCloseContactModal} />

      <Modal className='modal-profile' show={showRatingModal} onHide={() => setShowRatingModal(false)} scrollable centered>
        <Modal.Header closeButton><Modal.Title>Rate Agent</Modal.Title></Modal.Header>
        <Modal.Body>
          <Form onSubmit={saveRating}>
            <Form.Group className="mb-3">
              <Form.Label>
                Rating <span className="text-danger right-4">* </span>
              </Form.Label>
              
              <Rating
                fractions={1} // allow half-stars
                initialRating={rating}
                emptySymbol={<FaRegStar size={24} color="#ffc107" />}
                fullSymbol={<FaStar size={24} color="#ffc107" />}
                onChange={(rate) => setRating(rate)}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>
                Review <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={4}
                name="review"
                placeholder="write here..."
                value={review} onChange={(e) => setReview(e.target.value)}
                required
              />
            </Form.Group>


            <div className="d-flex justify-content-center gap-4">
              <Button className='custom-bttn style-2' onClick={() => setShowRatingModal(false)}>Cancel</Button>
              <Button type='submit' className='custom-bttn style-3'>Submit</Button>
            </div>
             <p className="text-center text-danger mt-2">
              {error}
            </p>
          </Form>
        </Modal.Body>
      </Modal>

    </section>
  );
}

export default RealEstateAgents;